import * as React from "react"
import PropTypes from "prop-types"
import { getImage } from "gatsby-plugin-image"
import SidebarTeaser from "./sidebarTeaser"

const LatestNews = ({ news }) => {
  const newsElements = news.edges.map((news) => {
    const {
      frontmatter,
      id,
    } = news.node

    const {
      slug,
      title,
      image,
    } = frontmatter

    const imageSrc = getImage(image)
    const fullSlug = `/news${slug}`

    return (
      <div
        className="border-top pt-2 mt-2"
        key={id}
      >
        <SidebarTeaser
          image={imageSrc}
          title={title}
          slug={fullSlug}
        />
      </div>
    )
  })

  return (
    <div className="latest-news">
      {newsElements}
    </div>
  )
}

LatestNews.propTypes = {
  news: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
}

export default LatestNews
